import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BUILD_STAMP_GET } from '../endpoints/build-stamp.endpoints';

/** `assets/build.json`, written by the deploy after the build (WAP-1816). */
export interface BuildStamp {
  sha: string;
  short: string;
  built_at: string;
  branch: string;
  /** package.json version of the deployed bundle, a date (WAP-1816). */
  version: string;
}

@Injectable({ providedIn: 'root' })
export class BuildStampApiService {
  private readonly http = inject(HttpClient);

  getStamp(): Observable<BuildStamp> {
    // The timestamp defeats any browser or proxy cache a host applies to assets/.
    return this.http.get<BuildStamp>(BUILD_STAMP_GET, {
      headers: { 'X-Skip-Loading': 'true' },
      params: { t: Date.now() },
    });
  }
}
